import React from 'react';
import { Switch, Route, } from 'react-router-dom';
import PageNotFound from './PageNotFound';

class RedirectPage extends React.Component {
    render() {
        return (
            <div>
                <Switch>
                    <Route path="/PageNotFound">
                        <PageNotFound />
                    </Route>
                </Switch>
            </div>
        );
    }
}

export default RedirectPage;


// WEBPACK FOOTER //
// ./src/routes/account/RedirectPage.js